<template>
    <form ref="form" @submit.prevent>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">센터관리</span>
            <span class="txt">센터의 이름, 주소, 전화번호 등 센터의 기본정보를 설정합니다.</span>
        </div>

        <div class="com-table-top">
            <div class="logo-area">
                <div class="logo-box">
                    <span class="logo">
                        <img :src="data.logoUrl" alt="" />
                    </span>
                </div>
                <div class="info-box">
                    <span class="location">{{ data.centerName }}</span>
                    <span class="address">
                        {{ data.address }} {{ data.addressDetail }} /
                        {{ `${data.telNo1 || ''}-${data.telNo2 || ''}-${data.telNo3 || ''}` }}
                    </span>
                    <span v-if="data.centerType == 'M'" class="type">본사</span>
                    <span v-else class="type">지점</span>
                </div>
            </div>
        </div>

        <div class="com-tab">
            <span v-for="(item, index) in submenus" :key="index">
                <router-link :class="{ on: $route.name == item.name }" :to="{ ...item, params: { centerId } }">
                    {{ item.label }}
                </router-link>
            </span>
        </div>

        <p class="sub-title">센터 기본정보</p>

        <div class="com-table-wrap">
            <div class="info-edit-table">
                <div class="table-wrapper">
                    <table>
                        <colgroup>
                            <col style="width: 156px" />
                            <col style="width: auto" />
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>로고</th>
                                <td>
                                    <div class="file-logo">
                                        <span v-if="data.logoUrl" class="logo"><img :src="data.logoUrl" alt="" /></span>
                                    </div>
                                    <div class="com-file-single">
                                        <b-form-file
                                            id="file1"
                                            accept=".jpg, .png, .gif"
                                            plain
                                            @change="handleImage"
                                        ></b-form-file>
                                        <label for="file1">파일첨부</label>
                                        <span class="info-txt">
                                            <span class="imp">*</span>
                                            흰 배경에 180px × 70px 사이즈 로고를 권장합니다.
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>센터구분</th>
                                <td>
                                    <div class="flex">
                                        <div class="com-radio">
                                            <input
                                                id="radio-1-1"
                                                v-model="data.centerType"
                                                disabled
                                                name="centerType"
                                                type="radio"
                                                value="M"
                                            />
                                            <label for="radio-1-1">본점</label>
                                        </div>
                                        <div class="com-radio">
                                            <input
                                                id="radio-1-2"
                                                v-model="data.centerType"
                                                disabled
                                                name="centerType"
                                                type="radio"
                                                value="C"
                                            />
                                            <label for="radio-1-2">지점</label>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    센터명
                                    <span class="imp">*</span>
                                </th>
                                <td>
                                    <input v-model="data.centerName" class="w400" required type="text" />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    전화번호
                                    <span class="imp">*</span>
                                </th>
                                <td>
                                    <div class="com-tel">
                                        <input v-model="data.telNo1" type="text" />
                                        <!-- validation 필수값 여부 제거(21.03.17) -->
                                        <span class="bar">-</span>
                                        <input v-model="data.telNo2" required type="text" />
                                        <span class="bar">-</span>
                                        <input v-model="data.telNo3" required type="text" />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>팩스번호</th>
                                <td>
                                    <div class="com-tel">
                                        <input v-model="data.faxNo1" type="text" />
                                        <span class="bar">-</span>
                                        <input v-model="data.faxNo2" type="text" />
                                        <span class="bar">-</span>
                                        <input v-model="data.faxNo3" type="text" />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>주소</th>
                                <td>
                                    <div class="com-address">
                                        <input v-model="data.address" class="address" type="text" />
                                        <button class="com-btn" @click="postPop = true">주소검색</button>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>상세주소</th>
                                <td>
                                    <input v-model="data.addressDetail" class="w400" type="text" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="bottom-btn">
            <router-link :to="{ name: 'SettingCenterList', query: $route.query }" class="com-btn" type="reset">
                취소
            </router-link>
            <button :disabled="isLoading" class="com-btn blue" type="submit" @click="save">저장</button>
        </div>

        <!-- 주소 검색 레이어 팝업 -->
        <div v-if="postPop === true" class="layer-pop square">
            <div class="view-content w600">
                <button class="close" @click="postPop = false"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y">
                    <span class="title">주소 검색</span>
                    <daum-post-code :on-complete="handleAddress"></daum-post-code>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
import api from '../../../assets/js/api';
import LoadingSpinner from '../../../components/LoadingSpinner';

export default {
    name: 'SettingCenterEdit',
    components: { LoadingSpinner },
    props: ['centerId'],
    computed: {},
    data() {
        return {
            isLoading: false,
            postPop: false,
            data: {},
            submenus: [
                { name: 'SettingCenterEdit', label: '기본정보' },
                { name: 'SettingCenterProgram', label: '프로그램 가입내역' },
                { name: 'SettingCenterHoliday', label: '휴일설정' },
                { name: 'SettingCenterAccount', label: '정산설정' },
                { name: 'SettingCenterPaymentList', label: '결제내역' },
                { name: 'SettingCenterPaymentMethod', label: '결제수단' },
                { name: 'SettingCenterFitpay', label: '핏페이' }, // TESTING ON PROD
                // { name: 'SettingCenterLecture', label: '교차수강설정' },
            ],
        };
    },
    mounted() {
        this.load();
    },
    methods: {
        load() {
            if (!this.centerId) return;
            this.isLoading = true;
            api.get(`/admin/api/center/${this.centerId}`)
                .then((res) => {
                    this.isLoading = false;
                    this.data = res.data;
                    let telNo = [];
                    if (this.data.telNo.length === 8) {
                        // 전화번호가 8글자일경우 적용됨(21.03.17)
                        telNo = this.data.telNo.match(/(\d{4})(\d{4})/);
                        telNo = ['', ...telNo];
                    } else if (this.data.telNo.indexOf('02') === 0) {
                        telNo = (this.data.telNo || '').match(/(\d{2})(\d{3,4})(\d{4})/);
                    } else if (this.data.telNo.length === 10) {
                        telNo = (this.data.telNo || '').match(/(\d{3})(\d{3})(\d{4})/);
                    } else {
                        telNo = (this.data.telNo || '').match(/(\d{3})(\d{4,4})(\d{4})/);
                    }

                    if (telNo) {
                        this.data.telNo1 = telNo[1];
                        this.data.telNo2 = telNo[2];
                        this.data.telNo3 = telNo[3];
                        this.data.telNo = telNo;
                    }

                    this.data.faxNo = (this.data.faxNo || '').match(/(\d{2,3})(\d{3,4})(\d{4})/);
                    if (this.data.faxNo) {
                        this.data.faxNo1 = this.data.faxNo[1];
                        this.data.faxNo2 = this.data.faxNo[2];
                        this.data.faxNo3 = this.data.faxNo[3];
                    }
                })
                .catch((res) => {
                    this.isLoading = false;
                    this.data = {};
                    if (res.response.status != 404) alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                    console.error(res);
                });
        },
        save() {
            if (!this.$refs.form.checkValidity() || this.isLoading) {
                return;
            }

            const data = eval(`(${JSON.stringify(this.data)})`);
            data.telNo = `${data.telNo1}${data.telNo2}${data.telNo3}`;
            data.faxNo = data.faxNo1 ? `${data.faxNo1}${data.faxNo2}${data.faxNo3}` : '';

            this.isLoading = true;
            api.put(`/admin/api/center/${this.centerId}`, data)
                .then((res) => {
                    this.isLoading = false;
                    alert('저장했습니다.');
                })
                .catch((res) => {
                    this.isLoading = false;
                    alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                    console.error(res);
                });
        },

        // Image 핸들러
        handleImage(e) {
            const selectedImage = e.target.files[0];
            this.data.logoImageFile = {
                filename: selectedImage.name,
                mimetype: selectedImage.type,
            };
            this.createBase64Image(selectedImage).onload = (e) => {
                this.data.logoUrl = e.target.result;
                this.data.logoImageFile.base64data = this.data.logoUrl.split(',')[1];
            };
        },

        // Base64 Image 생성
        createBase64Image(fileObj) {
            const reader = new FileReader();
            reader.readAsDataURL(fileObj);
            return reader;
        },

        // 다음 주소 API 콜백
        handleAddress(data) {
            let fullAddress = data.address;
            let extraAddress = '';
            if (data.addressType === 'R') {
                if (data.bname !== '') {
                    extraAddress += data.bname;
                }
                if (data.buildingName !== '') {
                    extraAddress += extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName;
                }
                fullAddress += extraAddress !== '' ? ` (${extraAddress})` : '';
            }
            this.data.address = fullAddress; // e.g. '서울 성동구 왕십리로2길 20 (성수동1가)'
            this.postPop = false;
        },
    },
};
</script>
<style lang="scss"></style>
